import constant from '../../constant';
import request from '../../../utils/request';
import { GET_HOT_RANK } from '../../../urls'
import {getAppName} from "../../../utils";
import {APP_INFO} from "../../../utils/constant";
import {initRMP} from "../../../utils/ClipperForRMP";

const getHotRank = () => {
  return async (dispatch) => {
    try {
        const res = await request.get(GET_HOT_RANK)

        if (res.code === 0) {
          dispatch(getHotRankSuccess(res.data));
          const list = res.data || [];
          const appName = getAppName();
          const urlMap = {};
          list.map(item => {
            urlMap[item.id] = APP_INFO[appName].hotRank.toSearchEndUrl.replace(/{keyword}/g, encodeURIComponent(item.title));
          });
          urlMap.moreHotRank = APP_INFO[appName].hotRank.toMoreUrl;
          initRMP([], 4, urlMap);
        }
    } catch (error) {
      console.log('getHotRank error',error)
    }
  }
}


const getHotRankSuccess = (hotRank) => {
  return {
    type: constant.SEARCH.GET_HOT_RANK,
    hotRank
  }
}


export default {
  getHotRank,
  getHotRankSuccess
}
